import styled from 'styled-components'
import get from 'lodash/get'
import {translate} from 'react-i18next'
import React from 'react'

const getColor = props => props.theme.link.secondary
const getHoverColor = props => props.theme.link.hoverColor
const getFontSize = props => props.theme.loginForm?.forgetLink?.link.fontSize
const getLineHeight = props => props.theme.secondaryFont.mobile.height
const getTextDecorationLine = props => get(props, 'theme.link.textDecoration', 'underline')
const getMarginTop = props => (props.error ? props.theme.loginForm?.forgetLink?.link?.marginTop : '4px')
const getHoverTextDecorationLine = props => get(props, 'theme.link.textDecorationHover', getTextDecorationLine(props))

const Link = styled.a`
  display: inline-block;
  box-sizing: border-box;
  color: ${getColor};
  cursor: pointer;
  text-decoration-line: ${getTextDecorationLine};
  text-decoration-color: ${getColor};
  font-size: ${getFontSize};
  line-height: ${getLineHeight};
  width: 100%;
  margin-top: ${getMarginTop};

  &:hover {
    color: ${getHoverColor};
    text-decoration-color: ${getHoverColor};
    text-decoration-line: ${getHoverTextDecorationLine};
  }
`

const LoginFormForgetLink = ({nativeLoginError, t, onClick}) => {
  if (nativeLoginError) {
    return null
  }

  return <Link onClick={onClick}>{t('forget.link')}</Link>
}

export default translate()(LoginFormForgetLink)
